import { SVGProps } from 'react';

export const LogoIconFletch = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.7695 0C20.8439 0 22.6575 1.11473 23.6455 2.77734L27.5752 4.38379L24.4385 6.71582V14.1338H24.4326C24.4044 15.9207 23.7106 17.5534 22.5752 18.8232L16.6865 26L10.9697 19.7266H14.4668V19.7256C16.8737 19.709 18.8193 17.7535 18.8193 15.3428C18.8191 12.9322 16.8735 10.9756 14.4668 10.959H12.2285L5.38867 19.7266H0L14.1299 2.41309C15.1554 0.95412 16.8507 9.16109e-05 18.7695 0ZM20.709 3.40137C20.1665 3.40154 19.7266 3.84124 19.7266 4.38379C19.7266 4.9263 20.1665 5.36604 20.709 5.36621C21.2516 5.36621 21.6914 4.92641 21.6914 4.38379C21.6914 3.84114 21.2516 3.40137 20.709 3.40137Z"
        fill="url(#paint0_linear_96_1375)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_96_1375"
          x1="25.8112"
          y1="21.8808"
          x2="14.5118"
          y2="-5.61684e-05"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#12403A" />
          <stop offset="1" stopColor="#2FA696" />
        </linearGradient>
      </defs>
    </svg>
  );
};
